import * as fromActions from '../actions/lessons-admin.action'
import { Reducer } from 'redux'
import { ILessonModel } from 'models/lesson.model'

export const initialState: any = {
  edit: [],
  loading: false,
  showWarning: undefined,
}

export const reducer: Reducer<ILessonModel> = (state: any = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.GET_LESSON: {
      return {
        ...state,
        loading: true,
      }
    }
    case fromActions.GET_LESSON_SUCCESS:
      return {
        ...state,
        edit: payload,
        loading: false,
      }
    case fromActions.SHOW_WARNING_LESSON:
      return {
        ...state,
        showWarning: payload,
      }
    default:
      return state
  }
}
